<template>
    <svg
        width="18"
        height="18"
        class="gst-svg-icon gst-svg-icon--stroke"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.267 15v-2 2Zm2.755 0v-4 4Zm2.756 0V9v6Zm1.837 4H3.43c-.488 0-.955-.21-1.3-.586A2.094 2.094 0 0 1 1.594 17V3c0-.53.193-1.04.538-1.414A1.764 1.764 0 0 1 3.43 1h5.13c.244 0 .478.105.65.293l4.973 5.414c.172.187.269.442.269.707V17c0 .53-.194 1.04-.538 1.414a1.764 1.764 0 0 1-1.3.586Z"
            stroke="#333"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
    </svg>
</template>
<script>
export default {
    name: 'IconProductsReports',
};
</script>
